import { TabComponetMobile } from 'app/components/TabComponetMobile';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { ReportPage } from '../ReportPage/loadable';
import IconButton from 'app/components/IconButton';
import { ConvertIcon } from 'app/assets/icons';
import useReportApi from 'app/hooks/useReportApi';
import { CONFIG } from '../ReportPage';
import { useParams } from 'react-router-dom';
import { useNavigateToRoute } from 'utils/common';
export const DashboardPage = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = React.useState(1);
  const { useRefreshMasterDataList, isLoading } = useReportApi();

  const reportId =
    activeTab === 1
      ? CONFIG.REPORT_ID_FACILITY
      : activeTab === 2
      ? CONFIG.REPORT_ID_LOAN
      : CONFIG.REPORT_ID_GUARANTEE;
  const handleRecall = () => {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };
  const refereshMasterDataListMutate = useRefreshMasterDataList(
    reportId,
    CONFIG.WORKSPACE_ID,
    handleRecall,
  );

  const { type } = useParams();
  const redirect = useNavigateToRoute();
  const defaultData = [
    { id: 1, title: 'Facility Dashboard' },
    { id: 2, title: 'Loan Dashboard' },
    { id: 3, title: 'Guarantee Dashboard' },
  ];
  const handleTabClick = (item: any) => {
    if (item.id === 1) {
      redirect(`/dashboard/facility`);
    } else if (item.id === 2) {
      redirect(`/dashboard/loan`);
    } else {
      redirect(`/dashboard/guarantee`);
    }
  };
  const commonIconButtonProps = {
    borderRadius: '4px',
    height: '26px',
    fontWeight: '600',
    hoverBgColor: theme.exportBtnHoverBg,
    hoverTextColor: theme.white,
    hoverBorderColor: theme.exportBtnHoverBg,
    hoverSvgColor: theme.white,
  };
  const handleRefreshClick = () => {
    refereshMasterDataListMutate.mutate();
  };

  React.useEffect(() => {
    setActiveTab(type === 'facility' ? 1 : type === 'loan' ? 2 : 3);
  }, [type]);
  return (
    <Wrapper>
      <div className="sub-wrapper">
        <TabComponetMobile
          className="tab-component-mobile"
          handleTabClick={handleTabClick}
          defaultData={defaultData}
          activeTab={activeTab}
        />
        <IconButton
          label={'Refresh'}
          svgIcon={
            <ConvertIcon
              className={isLoading ? 'spin' : ''}
              color={theme?.exportBtnHoverBg}
            />
          }
          bgColor={theme.black}
          borderColor={theme.black}
          textColor={theme.white}
          {...commonIconButtonProps} //common button props
          onClick={handleRefreshClick}
          disabled={isLoading}
        />
      </div>
      <TabContentWrapper>
        {activeTab === 1 && <ReportPage pageType={'facility'} />}
        {activeTab === 2 && <ReportPage pageType={'loan'} />}
        {activeTab === 3 && <ReportPage pageType={'guarantee'} />}
      </TabContentWrapper>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  border-top-right-radius: 26px;
  border-top-left-radius: 26px;
  .ul-wrapper {
    width: 430px;
    margin-left: 13px;
    justify-content: flex-start;
    gap: 24px;
  }
  .sub-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px 0 0;
    @media (min-width: 300px) and (max-width: 410px) {
      display: block;
      padding-left: 10px;
      .custom-btn-wrapper {
        padding-left: 10px;
      }
    }
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .spin {
      animation: spin 1s linear infinite;
    }
  }
`;

const TabContentWrapper = styled.div`
  padding: 0 27px 100px 27px;
`;
